import time from './time'

const today = new Date()
const yesterday = new Date()
const dayBeforeYesterday = new Date()
yesterday.setDate(today.getDate() - 1)
dayBeforeYesterday.setDate(today.getDate() - 2)

export default (value, options) => {
  if (!value) {
    return null
  }
  const date = new Date(value)

  if (options && options.markToday) {
    const parsedDate = relativeDateWords(date)
    if (parsedDate) {
      return parsedDate
    }
  }

  if (options && options.hideCurrentYear) {
    if (date.getFullYear() === today.getFullYear()) {
      return date.toLocaleString('et-ee', {
        day: '2-digit',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }

  return date.toLocaleString('et-ee', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

function relativeDateWords(date) {
  if (date.toDateString() === today.toDateString()) {
    return 'täna ' + time(date)
  }
  if (date.toDateString() === yesterday.toDateString()) {
    return 'eile ' + time(date)
  }
  if (date.toDateString() === dayBeforeYesterday.toDateString()) {
    return 'üleeile ' + time(date)
  }
  return false
}
